module.exports = "<ul class=\"nav nav-tabs\" ng-if=\"selectedObject\">\n    <li role=\"presentation\" class=\"clickable\" ng-class=\"{'disabled': object === null}\" ui-sref-active=\"active\">\n        <a ui-sref=\"^.detail\">Inventory</a>\n    </li>\n    <li role=\"presentation\" class=\"clickable\" ng-class=\"{'disabled': object === null}\" ui-sref-active=\"active\">\n        <a ui-sref=\"^.transactions\">Transactions</a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\" ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/inventory/templates/detail.section.html
// module id = 811
// module chunks = 0